// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCi7ljYe1OOKXxVYP6ZnJF-irZMH-94NgU",
  authDomain: "invoice-generator-99a02.firebaseapp.com",
  projectId: "invoice-generator-99a02",
  storageBucket: "invoice-generator-99a02.firebasestorage.app",
  messagingSenderId: "440410361232",
  appId: "1:440410361232:web:9652d4cfb483c5ba91f715",
  measurementId: "G-SXBWDB56BN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db, app };